import React, { useEffect, useState, useMemo } from "react";
import "../scss/Scss/Home.scss";
import { firestore } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

function TextAnimation({ onNavigateToHome, curPage, isMobile }) {
  const [dataCIWEB, setDataCIWEB] = useState(null);
  const [dataCISafetyEdit, setDataCISafetyEdit] = useState(null);

  useEffect(() => {
    const fetchDataCIWEB = async () => {
      try {
        const docRefCIWEB = doc(firestore, "CI WEB", "Home");
        const docSnapshot = await getDoc(docRefCIWEB);
        if (docSnapshot.exists()) {
          setDataCIWEB(docSnapshot.data());
        } else {
          console.log("No such document for CI WEB!");
        }
      } catch (error) {
        console.error("Error fetching document for CI WEB:", error);
      }
    };

    const fetchDataCISafetyEdit = async () => {
      try {
        const docRefCISafetyEdit = doc(
          firestore,
          "CI WEB - SAFETY EDIT",
          "Home"
        );
        const docSnapshot = await getDoc(docRefCISafetyEdit);
        if (docSnapshot.exists()) {
          setDataCISafetyEdit(docSnapshot.data());
        } else {
          console.log("No such document for CI WEB - SAFETY EDIT!");
        }
      } catch (error) {
        console.error(
          "Error fetching document for CI WEB - SAFETY EDIT:",
          error
        );
      }
    };

    if (!isMobile) {
      fetchDataCIWEB();
      fetchDataCISafetyEdit();
    }

    return () => {
      fetchDataCIWEB();
      fetchDataCISafetyEdit();
    };
  }, [curPage, isMobile]);

  const TextSlider = useMemo(() => {
    if (!dataCISafetyEdit || !dataCISafetyEdit.Loading) return null;
    const repeatedLoading = new Array(5).fill(dataCISafetyEdit.Loading);

    return (
      <div className="text-slider-container">
        <div className="text-slider">
          <div className="text">
            {repeatedLoading.map((loadingText, index) => (
              <span key={index}>{loadingText} </span>
            ))}
          </div>
        </div>
      </div>
    );
  }, [dataCISafetyEdit]);

  return (
    <>
      {dataCIWEB && dataCISafetyEdit && !isMobile && (
        <div className="TopBar">
          <div style={{ width: "100%" }} className="BgTextAnimation">
            <div className="TextAnimation">
              <div className="BoxSlide">
                {TextSlider}
                {curPage > 0 && (
                  <img
                    className="ToTopButton"
                    src={dataCIWEB.ToTopButton}
                    alt="IMG"
                    loading="lazy"
                    onClick={onNavigateToHome}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default TextAnimation;
